<template>
  <card header='Pie'>
    <svg-pie class="w5 ba" :series="series"></svg-pie>
  </card>
</template>

<script>
import Card from './Card.vue'
import SvgPie from '@/components/charts/svg/Pie.vue'

export default {
  components: {
    Card,
    SvgPie
  },
  data () {
    return {
      series: [
        { value: 10 },
        { value: 10 },
        { value: 10 },
        { value: 10 }
      ],
      series2: [
        { value: 10 },
        { value: 10 }
      ]
    }
  }
}
</script>
